module.exports = {
	"title": {
		"artist": "Ecoutez {artistName} sur Qobuz",
		"album": "Ecoutez l'album {albumName} de {artistName} sur Qobuz",
		"track": "Ecoutez {trackName} de {artistName} sur Qobuz",
		"playlist": "Ecoutez la playlist {playlistName} de {ownerName} sur Qobuz",
		"story": "Lisez cet Article sur Qobuz"
	},
	"buttons": {
		"listen": "Ecouter sur Qobuz",
		"buy": "Acheter",
		"share": "Partager",
		"download": "Essayer gratuitement",
		"readmore": "Lire la suite",
		"showless": "Afficher moins",
		"showmore": "Voir plus",
		"morealbums": "Plus d'albums sur Qobuz",
		"moreplaylisttrack": "Découvrir la suite sur Qobuz",
		"readfocus": "Lire ce Grand Angle sur Qobuz",
		"seeSubscribes": "Voir les offres d'abonnements",
		"cookies": "Paramètres cookies"
	},
	"infos": {
		"trackCount": "{count} pistes",
		"label": "Label : {label}",
		"composer": "Compositeur : {composer}",
		"producers": "Production",
		"mixers": "Mixage/mastering",
		"diskCount": "{count} albums",
		"duration": {
			"long": "{hours}h {minutes}m",
			"short": "{minutes}m {seconds}s"
		},
		"playlist": {
			"private": "Privée",
			"public": "Publique"
		},
		"hires": "Haute qualité",
		"available": "Disponible en"
	},
	"share": {
		"twitter": {
			"track": "Ecoutez {title} par {artist} sur Qobuz",
			"album": "Ecoutez {title} par {artist} sur Qobuz",
			"artist": "Ecoutez  {artist} sur Qobuz",
			"playlist": "Ecoutez {playlist} par {owner} sur Qobuz",
			"story": "Lisez cet article sur Qobuz"
		},
		"mail": {
			"track": {
				"subject": "{title} par {artist} est disponible sur Qobuz !",
				"body": "Ecoute {title} de {artist} avec Qobuz en haute qualité : {url}\n\nQobuz est le premier service d'écoute et de téléchargement de musique en haute qualité.\nPlus d'informations et inscription sur Qobuz.com\n\n"
			},
			"album": {
				"subject": "{title} par {artist} est disponible sur Qobuz !",
				"body": "Ecoute {title} de {artist} avec Qobuz en haute qualité : {url}\n\nQobuz est le premier service d'écoute et de téléchargement de musique en haute qualité.\nPlus d'informations et inscription sur Qobuz.com\n\n"
			},
			"artist": {
				"subject": "{artist} est sur Qobuz !",
				"body": "Ecoute {artist} avec Qobuz en haute qualité : {url}\n\nQobuz est le premier service d'écoute et de téléchargement de musique en haute qualité.\nPlus d'informations et inscription sur Qobuz.com\n\n"
			},
			"playlist": {
				"subject": "{playlist} par {owner} est disponible sur Qobuz !",
				"body": "Ecoute {playlist} de {owner} avec Qobuz en haute qualité : {url}\n\nQobuz est le premier service d'écoute et de téléchargement de musique en haute qualité.\nPlus d'informations et inscription sur Qobuz.com\n\n"
			},
			"story": {
				"subject": "{title}",
				"body": "À lire {url}\n\nQobuz est le premier service d'écoute et de téléchargement de musique en haute qualité.\nPlus d'informations et inscription sur Qobuz.com\n\n"
			}
		},
		"popup": {
			"clickToCopy": "Cliquer pour copier",
			"copy": "Copier",
			"copied": "Copié",
			"link": "Copier le lien suivant pour le partager"
		}
	},
	"tracklist": {
		"title": {
			"track": "Piste",
			"album": "Titres de l'album",
			"artist": "Les meilleurs titres",
			"artist_albums": "Albums",
			"playlist": "Titres de la playlist"
		},
		"header": {
			"number": "#",
			"name": "Titre",
			"album": "Album",
			"artist": "Artiste",
			"time": "Durée",
			"label": "Label"
		},
		"media_count": "CD {mediaNumber}",
		"noTracks": "Aucune piste disponible"
	},
	"story": {
		"404": {
			"title": "L’article que vous avez demandé n'existe pas dans votre zone géographique.",
			"description": "Retourner sur la page d'accueil du magazine Qobuz"
		},
		"from": "Par {author}",
		"albumOverlay": " - {releaseYear} - {genre}",
		"joinQobuz": "Rejoignez Qobuz pour lire l'article complet...",
		"signUp": "Essayer gratuitement"
	},
	"playlist": {
		"from": "Par {author}"
	},
	"album": {
		"by": "par",
		"publishedBy": "paru chez"
	},
	"notifications": {
		"nostream": "Les ayant-droits n'ont pas rendu possible l'écoute de cette piste"
	},
	"aside": {
		"title": "A propos"
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/locales/fr.json
// module id = 568
// module chunks = 0